import Superagent from 'superagent'
import ServerApi from './$server.api'

export default {
    getSigned,
    uploadFile
}

async function getSigned(data) {
    return await ServerApi.request('post', '/bucket/signed', {data})
}

function uploadFile(signed, file) {
    return new Promise((resolve, reject) => {

        Superagent
            .put(signed)
            .send(file)
            .end((err, res) => {
                resolve(res.body)
            })
    })
}